export default "__VITE_ASSET__a2629a0d__"